class StickyButton extends window.HTMLElement {
  constructor() {
    super();
    this.revealThreshold = 0;
    this.sectionElement = this.closest('.shopify-section');
    this.stickyElement = document.querySelector('[data-sticky]');
  }

  connectedCallback() {
  this.onScrollHandler = this.onScroll.bind(this);

  if (window.innerWidth < 600) {
    window.addEventListener('scroll', this.onScrollHandler, false);
  } else {
    // Make sure it's not sticky on desktop
    this.dataset.isSticky = 'false';
  }
}

  /**
   * Handles the scroll event and updates the visibility of the header based on
   * scroll position. The scroll event is wrapped in a setTimeout of 0 so that
   * the ResizeObserver callback will occur before the event fires. This allows
   * us to block the scroll event from firing when the user is resizing the
   * window as it will fire every time the window is resized.
   */
  onScroll() {
    setTimeout(() => {
      const { y } = this.getBoundingClientRect();
      if (y < this.revealThreshold) {
        this.dataset.isSticky = 'true';
        if (this.sectionElement)
          this.sectionElement.classList.add('has-sticky-button');
      } else {
        this.dataset.isSticky = 'false';
        if (this.sectionElement)
          this.sectionElement.classList.remove('has-sticky-button');
      }
    }, 0);
  }
  isVisibile() {
    return this.dataset.isSticky === 'true';
  }
}

window.customElements.define('sticky-button', StickyButton);